import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { TextSelection } from '@tiptap/pm/state';

import Component from './Component.jsx';

const Math = Node.create({
	name: 'math',

	group: 'inline',
	inline: true,
	atom: true,
	selectable: false,

	addAttributes() {
		return {
			value: {
				default: '',
			},
		};
	},

	addOptions() {
		return {
			HTMLAttributes: {},
		};
	},

	parseHTML() {
		return [
			{
				tag: 'math',
			},
		];
	},

	addCommands() {
		return {
			toggleMath:
				() =>
				({ chain }) => {
					return chain()
						.insertContent([
							{ type: this.name },
							{ type: 'text', text: ' ' },
						])
						.run();
				},
		};
	},

	addKeyboardShortcuts() {
		return {
			ArrowRight: ({ editor }) => {
				const { state, view } = editor;
				const { selection } = state;

				if (!selection.empty) {
					return false;
				}

				const { $from } = selection;
				const nodeAfter = $from.nodeAfter;

				if (nodeAfter?.type?.name !== this.name) {
					return false;
				}

				const positionAfterMath = selection.from + nodeAfter.nodeSize;
				view.dispatch(
					state.tr.setSelection(TextSelection.create(state.doc, positionAfterMath))
				);
				return true;
			},
			ArrowLeft: ({ editor }) => {
				const { state, view } = editor;
				const { selection } = state;

				if (!selection.empty) {
					return false;
				}

				const { $from } = selection;
				const nodeBefore = $from.nodeBefore;

				if (nodeBefore?.type?.name !== this.name) {
					return false;
				}

				const positionBeforeMath = selection.from - nodeBefore.nodeSize;
				view.dispatch(
					state.tr.setSelection(TextSelection.create(state.doc, positionBeforeMath))
				);
				return true;
			},
		};
	},

	renderHTML({ HTMLAttributes }) {
		return ['math', HTMLAttributes];
	},

	addNodeView() {
		return ReactNodeViewRenderer(Component);
	},
});

export default Math;
